import { Link } from 'react-router-dom';
import { Button, Card, CardContent } from '../../../components/ui';
import { useLanguageStore } from '../../../store/languageStore';
import { getUITranslation } from '../i18n/translations';

export const KanbanBoardHome = () => {
  const { language } = useLanguageStore();
  const t = getUITranslation(language);

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="mx-auto max-w-5xl">
        <section className="mb-16 text-center">
          <h1 className="mb-4 text-5xl font-bold md:text-6xl lg:text-7xl">
            <span className="bg-gradient-to-r from-primary via-purple-500 to-pink-500 bg-clip-text text-transparent">
              {t.home.title}
            </span>
          </h1>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground md:text-xl">
            {t.home.subtitle}
          </p>
        </section>

        <section className="mb-16 grid gap-8 md:grid-cols-2">
          <Card className="group relative overflow-hidden border-2 bg-gradient-to-br from-primary/10 via-transparent to-secondary/10 transition-all hover:border-primary/40 hover:shadow-lg">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
            <CardContent className="relative flex h-full flex-col items-center p-8 text-center">
              <div className="mb-4 text-6xl">📋</div>
              <h2 className="mb-2 text-2xl font-bold">{t.home.createRoomTitle}</h2>
              <p className="mb-6 text-muted-foreground">{t.home.createRoomDescription}</p>
              <Link to="/apps/kanban-board/create" className="mt-auto w-full">
                <Button size="lg" className="w-full">
                  {t.home.createRoom}
                </Button>
              </Link>
            </CardContent>
          </Card>

          <Card className="group relative overflow-hidden border-2 bg-gradient-to-br from-secondary/10 via-transparent to-primary/10 transition-all hover:border-primary/40 hover:shadow-lg">
            <div className="absolute inset-0 bg-gradient-to-br from-secondary/5 via-transparent to-transparent opacity-0 transition-opacity group-hover:opacity-100" />
            <CardContent className="relative flex h-full flex-col items-center p-8 text-center">
              <div className="mb-4 text-6xl">🚪</div>
              <h2 className="mb-2 text-2xl font-bold">{t.home.joinRoomTitle}</h2>
              <p className="mb-6 text-muted-foreground">{t.home.joinRoomDescription}</p>
              <Link to="/apps/kanban-board/join" className="mt-auto w-full">
                <Button size="lg" variant="outline" className="w-full">
                  {t.home.joinRoom}
                </Button>
              </Link>
            </CardContent>
          </Card>
        </section>

        <section>
          <div className="relative overflow-hidden rounded-3xl border bg-gradient-to-br from-primary/5 via-transparent to-secondary/10 p-8 md:p-12">
            <div className="absolute right-0 top-0 h-32 w-32 rounded-full bg-primary/10 blur-3xl" />
            <div className="relative">
              <h3 className="mb-4 text-3xl font-bold">{t.home.whatIsTitle}</h3>
              <div className="space-y-4 text-muted-foreground">
                <p>{t.home.description1}</p>
                <p>{t.home.description2}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
